export default "__VITE_ASSET__0f1aa93f__"